import React, { useEffect, useState } from 'react';
import Spinner from '../../../../../components/common/spinner';
import Title from '../../../../../components/common/title';
import CurrentFieldStatusWithLadTable from './components/current-field-status-with-lad-table';
import FieldsNotRegisteredInLadTable from './components/fields-not-registered-in-lad-table';
import MappingTable from './components/mapping-table';
import { FieldsForMappingProvider } from './components/synchronize-context';
import { useTable } from './components/use-synchronize';
import css from './synchronize.module.css';
import FieldSearchForMapping from './components/field-search-for-mapping';
import NewMap from '../components/newmap';
import MapActionType from '../../../../../enums/map-action-type';

export default function SynchronizeFieldsWithLad() {
  const { t, tp, farmId, season, fieldService } = useTable();
  const [ladDataError, setLadDataError] = useState(null);
  const [loadingData, setLoadingData] = useState(false);

  useEffect(() => {
    setLoadingData(true);

    const subscription = fieldService
      .ladApiDataStatus(farmId, season)
      .subscribe((response: any) => {
        if (response === null) {
          setLadDataError(tp('api_error'));
        } else {
          setLadDataError(
            response.hasOwnProperty('error') ? response.error : false
          );
        }

        setLoadingData(false);
      });
    return () => subscription.unsubscribe();
  }, [fieldService, farmId, season, setLadDataError, tp]);

  const error = <div className={css['error-message']}>{ladDataError}</div>;

  const loading = (
    <div className={css['loading']}>
      <div>{t('Loading')}</div>
      <Spinner visible={true} size="lg" />
    </div>
  );

  const content = () => {
    if (loadingData) {
      return loading;
    } else if (ladDataError === false) {
      return (
        <>
          <FieldsForMappingProvider>
            <div className="transition-all w-full md:w-2/3 max-h-screen overflow-y-auto gap-8 flex flex-col md:h-full h-1/2">
              <MappingTable />
              <FieldsNotRegisteredInLadTable />
              <CurrentFieldStatusWithLadTable />
            </div>
            <div className="transition-all flex justify-center items-center w-full flex-col gap-4 md:gap-0 md:w-1/3 md:h-full h-1/2 md:relative">
              <FieldSearchForMapping />
              <NewMap type={MapActionType.lad} />
            </div>
          </FieldsForMappingProvider>
        </>
      );
    } else {
      return error;
    }
  };

  const style =
    loadingData || ladDataError || ladDataError === null ? '' : 'bg-white';

  return (
    <>
      <Title title={tp('title')} />
      <div
        className={`transition-all flex w-full h-full ${style} flex-col-reverse md:flex-row gap-8 md:gap-0`}
      >
        {content()}
      </div>
    </>
  );
}
